

exports.__esModule = true;
exports.$xoTopupAmountRoute = undefined;

var _index = require('squid/index');

var _directive = require('./directive');

var _directive2 = _interopRequireDefault(_directive);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var $xoTopupAmountRoute = exports.$xoTopupAmountRoute = _index.$Route.extend('$xoTopupAmountRoute', {
    path: 'topupAmount',
    directive: _directive2['default'],
    children: []
});

exports['default'] = $xoTopupAmountRoute;

angular.value("$xoTopupAmountRoute", $xoTopupAmountRoute);
_index.$Route;


//////////////////
// WEBPACK FOOTER
// ../node_modules/xo-wallet-components/src/topup/topup-amount/route.js
// module id = ../node_modules/xo-wallet-components/src/topup/topup-amount/route.js
// module chunks = 0